/**
 * @generated SignedSource<<19850aea13f4614592fa824aeec190f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type column_workManagementBoard_BoardColumn$data = {
  readonly " $fragmentSpreads": FragmentRefs<"card_workManagementBoard_queryFragment">;
  readonly " $fragmentType": "column_workManagementBoard_BoardColumn";
};
export type column_workManagementBoard_BoardColumn$key = {
  readonly " $data"?: column_workManagementBoard_BoardColumn$data;
  readonly " $fragmentSpreads": FragmentRefs<"column_workManagementBoard_BoardColumn">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "column_workManagementBoard_BoardColumn",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "card_workManagementBoard_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "0a2af42ae678306d86e11881ef187066";

export default node;
